import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import {
  Button,
  Modal,
  Form,
  ModalBody,
  Card,
  CardBody,
  CardHeader,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import ContractTab from "./ContractTab";
import UnitsTab from "./UnitsTab";
import PaymentsTab from "./PaymentsTab";
import FileUploadTab from "./FileUploadTab";
import { addDocument as onAddDocument } from "../../../slices/thunks";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import ClientModal from "../../Client/ClientModal/ClientModal";

import {
  addNewContract as onAddNewContract,
  getUnitById as onGetUnitById,
  getContracts as onGetContracts,
  extractDocument as onExctractDocument,
} from "../../../slices/thunks";
import "react-toastify/dist/ReactToastify.css";

import classnames from "classnames";

const ContractModal = ({ show, onCloseClick, clientDetails }) => {
  const [activeArrowTab, setactiveArrowTab] = useState(1);
  const [passedarrowSteps, setPassedarrowSteps] = useState([1]);
  const [file, setFile] = useState(null);
  const [documentType, setDocumentType] = useState("CONTRACT");
  const [description, setDescription] = useState("");
  const [extractedData, setExtractedData] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [extractedPersonalData, setExtractedPersonalData] = useState(null);
  const [clientModal, setClientModal] = useState(false);
  const [clientType, setClientType] = useState("NATURAL");
  const [tempExtractedData, setTempExtractedData] = useState(null);
  const [valPay, setValPay] = useState(null);
  const waitingForClientRef = useRef(false);

  const { contracts } = useSelector((state) => {
    return state.Contract;
  });
  const { clients } = useSelector((state) => state.Clients);

  const prevClientsLengthRef = useRef(clients?.length || 0);

  const [settledPrice, setSettledPrice] = useState(0);
  const [extraPayments, setExtraPayments] = useState(0);
  const dispatch = useDispatch();

  function toggleArrowTab(tab) {
    if (activeArrowTab !== tab) {
      var modifiedSteps = [...passedarrowSteps, tab];

      if (tab >= 1 && tab <= 4) {
        setactiveArrowTab(tab);
        setPassedarrowSteps(modifiedSteps);
      }
    }
  }

  useEffect(() => {
    dispatch(onGetContracts());
  }, [dispatch]);

  useEffect(() => {
    if (
      waitingForClientRef.current &&
      clients?.length > prevClientsLengthRef.current &&
      tempExtractedData
    ) {
      const newClientIndex = clients.length - 1;
      const newClient = clients[newClientIndex];

      const updatedData = {
        ...tempExtractedData.data,
        personal_data: {
          ...tempExtractedData.data.personal_data,
          id: newClient.id,
        },
      };

      processExtractedData(updatedData);

      waitingForClientRef.current = false;
      setTempExtractedData(null);
      prevClientsLengthRef.current = clients.length;
    } else {
      prevClientsLengthRef.current = clients?.length || 0;
    }
  }, [clients]);

  useEffect(() => {
    if (!file) {
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    setUploading(true);

    resetExtractedData();

    dispatch(onExctractDocument(formData))
      .unwrap()
      .then(async (extractedData) => {
        setExtractedData(extractedData);

        if (extractedData && extractedData.data) {
          const data = extractedData.data;

          if (!data.personal_data || !data.personal_data.id) {
            if (data.personal_data) {
              setExtractedPersonalData({
                name: data.personal_data.name || "",
                surname: data.personal_data.surname || "",
                social_security_number:
                  data.personal_data.ssn ||
                  data.personal_data.social_security_number ||
                  "",
                social_security_series:
                  data.personal_data.ssn_series ||
                  data.personal_data.social_security_series ||
                  "",
                mobile_phone_number:
                  data.personal_data.phone ||
                  data.personal_data.mobile_phone_number ||
                  "",
                personal_email:
                  data.personal_data.email ||
                  data.personal_data.personal_email ||
                  "",
                address: data.personal_data.address || "",
                country: data.personal_data.country || "",
                city: data.personal_data.city || "",
                region: data.personal_data.region || "",
              });
            }
            if (data.personal_data) {
              setClientModal(true);

              setTempExtractedData(extractedData);

              waitingForClientRef.current = true;

              if (data.personal_data && data.personal_data.type) {
                setClientType(data.personal_data.type);
              } else {
                setClientType("NATURAL");
              }
            }
          } else {
            await processExtractedData(extractedData.data);
          }
        }
        setUploading(false);
      })
      .catch((error) => {
        console.error("Error:", error);
        setUploading(false);
      });
  }, [file, dispatch]);

  const processExtractedData = async (data) => {
    try {
      const unitsArray = await Promise.all(
        data.settlement_data.settlements.map(async (settlement, index) => {
          const unitId = settlement.unit_id.toString();
          const unitData = await dispatch(onGetUnitById(unitId)).unwrap();

          return {
            unitId: unitId,
            settled_price: settlement.amount || unitData.settledPrice,
            extras: 0,
            is_unit_sold: data.property_data.units[index].is_sold || 0,
            unit_type: unitData.unit_type || "",
            unit_project: unitData.project || "",
            unit_phase: unitData.phase || "",
            unit_block: unitData.block || "",
            unit_nr: unitData.nr || "",
            unit_floor: unitData.floor || 0,
            unit_sqm: unitData.net_sqm || 0,
          };
        })
      );

      const paymentsArray = data.payments_data.section.map((section) => {
        let formattedBookingDate = null;
        if (section.booking_date) {
          const parsedDate = moment(section.booking_date, [
            "DD.MM.YYYY",
            "MM/DD/YYYY",
            "YYYY-MM-DD",
            "DD/MM/YYYY",
            "MM.DD.YYYY",
            "YYYY.MM.DD",
          ]);

          if (parsedDate.isValid()) {
            formattedBookingDate = parsedDate.format("YYYY-MM-DDT00:00");
          }
        }
        return {
          type: section.pay_type,
          booking_date: formattedBookingDate || null,
          vat_percentage: data.settlement_data.tva || 0,
          isPaid: false,
          cashed_date: null,

          unitAmounts: section.payments.map((payment) => {
            const matchedUnit = unitsArray.find(
              (unit) => Number(unit.unitId) === Number(payment.unit_id)
            );

            return {
              unit_id: Number(payment.unit_id),
              unit_type: matchedUnit?.unit_type || "",
              unit_nr: matchedUnit?.unit_nr || "",
              amount: Number(payment.amount),
              cashed: null,
            };
          }),
        };
      });

      setValPay(paymentsArray);

      validation.setValues({
        ...validation.values,
        pvc_number:
          data.contract_data.pvc_number || validation.values.pvc_number,
        pvc_date: data.contract_data.pvc_date || validation.values.pvc_date,
        type: data.contract_data.contract_type || validation.values.type,
        notary: data.contract_data.notary || validation.values.notary,
        client: data.personal_data.id || validation.values.client,
        units: unitsArray || validation.values.units,
        payments: paymentsArray,
      });
    } catch (error) {
      console.error("Error processing extracted data:", error);
    }
  };

  const resetExtractedData = () => {
    setExtractedData(null);
    validation.setValues({
      ...validation.values,
      pvc_number: "",
      pvc_date: "",
      type: "",
      notary: "",
      client: clientDetails ? clientDetails.id : "",
      units: [],
      payments: [],
    });
  };

  const handleClientModalClose = () => {
    setClientModal(false);
    setExtractedPersonalData(null);

    if (waitingForClientRef.current) {
      waitingForClientRef.current = false;
      setTempExtractedData(null);
    }
  };

  const handleCloseModal = () => {
    onCloseClick();
    setactiveArrowTab(1);
    validation.resetForm();
    setSettledPrice(0);
    setExtraPayments(0);
    setFile(null);
    setDescription("");
    setExtractedData(null);
    setExtractedPersonalData(null);
    setTempExtractedData(null);
    waitingForClientRef.current = false;
  };

  function getValidationSchema(tab) {
    switch (tab) {
      case 1:
        return Yup.object({});
      case 2:
        return Yup.object({
          pvc_number: Yup.string()
            .required("Please Enter PVC Number")
            .test("unique-pvc", "PVC Number already exists", function (value) {
              if (!value) return true;
              return !contracts.some(
                (contract) => contract.pvc_number == value
              );
            }),
          pvc_date: Yup.string().required("Please Enter PVC Date"),
          type: Yup.string().required("Please Select Contract Type"),
          client: Yup.string().required("Please Select Contract Client"),
        });
      case 3:
        return Yup.object({
          units: Yup.array()
            .of(
              Yup.object().shape({
                unitId: Yup.string().required("Unit is required"),
                unit_project: Yup.string(),
                unit_phase: Yup.string(),
                unit_block: Yup.string(),
                unit_nr: Yup.string(),
                unit_floor: Yup.number().default(0),
                unit_sqm: Yup.number().default(0),
                extras: Yup.number().default(0),
                is_unit_sold: Yup.number().test(
                  "is-not-sold",
                  "This unit is already sold",
                  function (value) {
                    return value !== 1;
                  }
                ),
                settled_price: Yup.number()
                  .min(1, "Price must be greater than 0")
                  .required("Price is required"),
              })
            )
            .min(1, "Please select at least one unit"),
        });

      case 4:
        return Yup.object({
          settled_price: Yup.string(),
          payments: Yup.array()
            .of(
              Yup.object().shape({
                type: Yup.string().required("Please select Payment Type"),
                booking_date: Yup.string().required(
                  "Please select Payment Date"
                ),
                unitAmounts: Yup.array()
                  .of(
                    Yup.object().shape({
                      unit_id: Yup.number().required("Unit ID is required"),
                      amount: Yup.number()
                        .min(1, "Amount must be greater than 0")
                        .required("Please enter an amount"),
                    })
                  )
                  .min(1, "At least one unit amount is required"),
              })
            )
            .min(1, "Please add at least one payment"),
          remaining_balance: Yup.number().test(
            "check-remaining-balance",
            "Remaining balance should be 0",
            (value) => value === 0
          ),
        });
      default:
        return Yup.object({});
    }
  }

  const handleFileChange = (selectedFile) => setFile(selectedFile);
  const handleDocumentTypeChange = (type) => setDocumentType(type);
  const handleDescriptionChange = (desc) => setDescription(desc);

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      id: "",
      pvc_number: "",
      pvc_date: "",
      created_at: "",
      notary: "",
      notes: "",
      type: "",
      units: [],
      client: clientDetails ? clientDetails.id : "",
      project: "",
      block: "",
      phase: "",
      settled_price: settledPrice,
      balance: "",
      booking_date: "",
      amount: "",
      settlement_price: "",
      extra_payments: extraPayments,
      payments: [],
      remaining_balance: settledPrice,
    },
    validationSchema: getValidationSchema(activeArrowTab),

    onSubmit: async (values) => {
      try {
        const client_id = clientDetails ? clientDetails.id : values.client;

        const contractData = {
          pvc_number: values.pvc_number,
          pvc_date: values.pvc_date,
          notary: values.notary,
          notes: values.notes,
          type: values.type,
          client: client_id,
          units: values.units.map(unit => ({
            id: unit.unitId,
            settlement_price: {
              settled_price: parseInt(unit.settled_price) + parseInt(unit.extras || 0) || 0,
              payments: values.payments.flatMap(payment => 
                payment.unitAmounts
                  .filter(unitAmount => parseInt(unitAmount.unit_id) === parseInt(unit.unitId))
                  .map(unitAmount => ({
                    type: payment.type,
                    vat_percentage: payment.vat_percentage,
                    booking_date: payment.booking_date,
                    amount: unitAmount.amount,
                    cashed: payment.isPaid
                      ? unitAmount.cashed || parseInt(unitAmount.amount) || 0
                      : null,
                    cashed_date: payment.isPaid ? payment.cashed_date : null,
                  }))
              )
            }
          }))
        };

        const resultAction = await dispatch(onAddNewContract(contractData));

        const createdContract = resultAction.payload;
        if (createdContract?.id) {
          handleUpload(createdContract.id);
        }

        handleCloseModal();
      } catch (error) {
        console.error("Error creating contract:", error);
      }
    },
  });

  const handleUpload = async (contract_id) => {
    if (!file) {
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("contract", contract_id);
    formData.append("document_type", documentType);
    if (description.trim()) {
      formData.append("description", description);
    }
    setUploading(true);
    try {
      await dispatch(onAddDocument(formData)).unwrap();

      setFile(null);
      setDescription("");
      if (typeof onUploadSuccess === "function") {
        onUploadSuccess();
      }
    } catch (error) {
      console.error("Document upload error:", error);
      // alert(error.message || "Failed to upload document");
    } finally {
      setUploading(false);
    }
  };

  const handleNext = () => {
    if (activeArrowTab === 1) {
      toggleArrowTab(activeArrowTab + 1);
      return;
    }
    validation.validateForm().then((errors) => {
      if (Object.keys(errors).length === 0) {
        toggleArrowTab(activeArrowTab + 1);
      } else {
        validation.setTouched(
          Object.keys(errors).reduce((acc, key) => {
            acc[key] = true;
            return acc;
          }, {}),
          true
        );
      }
    });
  };

  return (
    <div>
      <ClientModal
        show={clientModal}
        clientOption={clientType}
        onCloseClick={handleClientModalClose}
        extractedPersonalData={extractedPersonalData}
      />
      <Modal
        isOpen={show}
        toggle={onCloseClick}
        centered
        style={{
          maxWidth: "80%",
          width: "100%",
          backgroundColor: "transparent",
          border: "none",
          boxShadow: "none",
          "--vz-modal-bg": "transparent",
          "--vz-modal-border-color": "transparent",
        }}
      >
        <Form className="tablelist-form" onSubmit={validation.handleSubmit}>
          <ModalBody>
            <div className="page-content">
              <Row>
                <Card>
                  <CardHeader>
                    <div className="hstack gap-2 justify-content-end">
                      <Button
                        className="btn btn-light"
                        color="secondary"
                        onClick={handleCloseModal}
                      >
                        <i className="ri-close-line"></i>
                      </Button>
                    </div>
                  </CardHeader>
                  <CardBody className="form-steps">
                    <div className="step-arrow-nav mb-4">
                      <Nav
                        className="nav-pills custom-nav nav-justified"
                        role="tablist"
                      >
                        <NavItem>
                          <NavLink
                            id="steparrow-upload-tab"
                            className={classnames({
                              active: activeArrowTab === 1,
                              done: activeArrowTab <= 4 && activeArrowTab > 1,
                            })}
                          >
                            Upload Contract
                          </NavLink>
                        </NavItem>

                        <NavItem>
                          <NavLink
                            id="steparrow-contract-tab"
                            className={classnames({
                              active: activeArrowTab === 2,
                              done: activeArrowTab <= 4 && activeArrowTab > 2,
                            })}
                          >
                            Contract Details
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            id="steparrow-units-tab"
                            className={classnames({
                              active: activeArrowTab === 3,
                              done: activeArrowTab <= 4 && activeArrowTab > 3,
                            })}
                          >
                            Select Unit
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            id="steparrow-payments-tab"
                            className={classnames({
                              active: activeArrowTab === 4,
                              done: activeArrowTab <= 4 && activeArrowTab > 4,
                            })}
                          >
                            Set Payments
                          </NavLink>
                        </NavItem>
                      </Nav>
                    </div>

                    <TabContent activeTab={activeArrowTab}>
                      {/* File Upload Tab */}
                      <TabPane id="steparrow-upload-info" tabId={1}>
                        <FileUploadTab
                          file={file}
                          onFileChange={handleFileChange}
                          documentType={documentType}
                          onDocumentTypeChange={handleDocumentTypeChange}
                          description={description}
                          onDescriptionChange={handleDescriptionChange}
                        />
                        {extractedData ? (
                          <div className="mt-3">
                            <div className="alert alert-success">
                              <i className="ri-check-line me-2"></i>
                              Document data extracted successfully!
                              {extractedData.data?.contract_data && (
                                <div className="mt-1">
                                  <strong>Contract Data Fields:</strong>{" "}
                                  {Object.entries(
                                    extractedData.data.contract_data
                                  )
                                    .filter(([_, value]) => value !== "")
                                    .map(([key]) => (
                                      <span
                                        key={key}
                                        className="badge bg-secondary me-1 text-capitalize"
                                      >
                                        {key.replace(/_/g, " ")}
                                      </span>
                                    ))}
                                </div>
                              )}
                              {extractedData.data?.personal_data && (
                                <div className="mt-1">
                                  <strong>Personal Data Fields:</strong>{" "}
                                  {Object.entries(
                                    extractedData.data.personal_data
                                  )
                                    .filter(([_, value]) => value !== "")
                                    .map(([key]) => (
                                      <span
                                        key={key}
                                        className="badge bg-secondary me-1 text-capitalize"
                                      >
                                        {key.replace(/_/g, " ")}
                                      </span>
                                    ))}
                                </div>
                              )}
                              {extractedData.data?.settlement_data?.settlements
                                ?.length > 0 && (
                                <div className="mt-1">
                                  <strong>Units found:</strong>{" "}
                                  {
                                    extractedData.data.settlement_data
                                      .settlements.length
                                  }
                                </div>
                              )}
                            </div>
                          </div>
                        ) : null}
                      </TabPane>

                      {/* Contract Tab */}
                      <TabPane id="steparrow-contract-info" tabId={2}>
                        <ContractTab
                          formik={validation}
                          clientDetails={clientDetails}
                        />
                      </TabPane>

                      {/* Units Tab */}
                      <TabPane id="steparrow-units-info" tabId={3}>
                        <UnitsTab formik={validation} />
                      </TabPane>

                      {/* Payments Tab */}
                      <TabPane id="steparrow-payments-info" tabId={4}>
                        <PaymentsTab formik={validation} />
                      </TabPane>
                    </TabContent>

                    <div className="d-flex align-items-start gap-3 mt-4">
                      <button
                        type="button"
                        className="btn btn-light btn-label previestab"
                        onClick={() => toggleArrowTab(activeArrowTab - 1)}
                        disabled={activeArrowTab === 1}
                      >
                        <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2"></i>{" "}
                        Back
                      </button>
                      {activeArrowTab !== 4 ? (
                        <button
                          type="button"
                          className="btn btn-success btn-label right ms-auto nexttab"
                          onClick={handleNext}
                        >
                          <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2"></i>
                          Next
                        </button>
                      ) : (
                        <button
                          type="button"
                          className="btn btn-success btn-label right ms-auto nexttab"
                          onClick={async (e) => {
                            e.preventDefault();
                            validation.handleSubmit();
                          }}
                        >
                          <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2"></i>
                          {uploading ? "Uploading..." : "Submit"}
                        </button>
                      )}
                    </div>
                  </CardBody>
                </Card>
              </Row>
            </div>
          </ModalBody>
        </Form>
      </Modal>
    </div>
  );
};

ContractModal.propTypes = {
  show: PropTypes.bool,
  onCloseClick: PropTypes.func,
  clientDetails: PropTypes.object,
};

export default ContractModal;
